import { JSX } from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import ProblemSection from "./components/ProblemSection";
import StatisticsSection from "./components/StatisticsSection";
import FeaturesSection from "./components/FeaturesSection";
import PetStoriesSection from "./components/PetStoriesSection";
import TestimonialsSection from "./components/TestimonialsSection";
import MissionSection from "./components/MissionSection";
import DownloadAppSection from "./components/DownloadAppSection";
import ContactSection from "./components/ContactSection";
import FooterSection from "./components/FooterSection";
import { LazyMotion, domAnimation } from "motion/react";

const styles = {
  bubbles: "fixed inset-0 pointer-events-none -z-10",
  section: "py-16",
  testimonios: "",
  contacto: "py-16",
};

const WelcomeContainer = (): JSX.Element => {
  const bubbles = Array.from({ length: 4 }).map((_, i) => (
    <div
      key={i}
      className="bubble"
      style={{ bottom: `-${100 + Math.random() * 100}px` }}
    />
  ));

  return (
    <LazyMotion features={domAnimation}>
      <Helmet>
        <title>AppCotas | Gestión Profesional para Clínicas Veterinarias</title>
        <meta
          name="description"
          content="Optimiza tu clínica veterinaria con AppCotas. Gestión de citas, historiales médicos digitales y recordatorios automáticos en una sola plataforma."
        />
        <link rel="canonical" href="https://appcotas.ai/" />
      </Helmet>
      <div className={styles.bubbles} aria-hidden="true">
        {bubbles}
      </div>
      <header>
        <Navbar />
      </header>
      <main>
        <section aria-label="Hero">
          <HeroSection />
        </section>

        <section id="problem" aria-label="Problema">
          <ProblemSection />
        </section>

        <section
          id="more-info"
          className={styles.section}
          aria-label="Características"
        >
          <FeaturesSection />
        </section>

        <section className={styles.section} aria-label="Estadísticas">
          <StatisticsSection />
        </section>

        <section className={styles.section} aria-label="Historias de Mascotas">
          <PetStoriesSection />
        </section>

        <section className={styles.testimonios} aria-label="Testimonios">
          <TestimonialsSection />
        </section>

        <section id="mission" className={styles.section} aria-label="Misión">
          <MissionSection />
        </section>

        <section className={styles.section} aria-label="Descarga">
          <DownloadAppSection />
        </section>

        <section id="contact" className={styles.contacto} aria-label="Contacto">
          <ContactSection />
          <FooterSection />
        </section>
      </main>
    </LazyMotion>
  );
};
export default WelcomeContainer;
